import { BARE_METAL_NODES_OPTION_META_KEYS } from '../../capabilities/bare-metal-nodes/fieldKeys';
import { buildVendorDeviceMetaWatchFields } from '../../components/vendorDevice';
import { resolvePricingResourceCodes, resolveWatchFieldsFromResourceConfigs } from '../../platform/pipeline-kernel/resolveResourceWatch';
import type { ResourceConfigEntry, ResourceType, SkuModuleMeta } from '../../platform/pipeline-kernel/types';

export const bareMetalNodeResource: ResourceType = {
  requirement: '1', // 写死为1
  code: 'BareMetalNode',
  description: '裸金属节点',
  unit: '台',
};

export const BARE_METAL_RESOURCE_CONFIGS: ResourceConfigEntry[] = [
  {
    ...bareMetalNodeResource,
    watchFields: ['bmsNode', 'optionMeta', ...buildVendorDeviceMetaWatchFields(`optionMeta.${BARE_METAL_NODES_OPTION_META_KEYS.node}`)],
    displayIds: ['node'],
  },
];

export const BARE_METAL_SKU_MODULE_META: Record<string, SkuModuleMeta> = {
  baseInfo: {
    resource: false,
    presetCheckFields: ['name'],
  },
  network: {
    resource: false,
    presetCheckFields: ['vpc.name'],
    fieldPresetPaths: {
      'network.staticIpv4': ['network.staticIpv4', 'staticIpv4'],
    },
  },
  systemSetting: {
    resource: true,
    presetCheckFields: ['image.url', 'image.key', 'powerPolicy', 'provisioning.mode', 'boot.mode'],
    fieldPresetPaths: {
      'provisioning.mode': ['provisioning.mode'],
      'boot.mode': ['boot.mode'],
      'systemVolume.architecture': ['systemVolume.architecture'],
      'systemVolume.os': ['systemVolume.os'],
      'systemVolume.version': ['systemVolume.version'],
    },
  },
  bareMetalNodes: {
    resource: false,
    presetCheckFields: [],
  },
  service: {
    resource: false,
    presetCheckFields: ['network.service'],
    orderListItemLock: true,
  },
};

export function resolveBareMetalResourceWatchFields(configs: ResourceConfigEntry[] = BARE_METAL_RESOURCE_CONFIGS): string[] {
  return resolveWatchFieldsFromResourceConfigs(configs);
}

export function resolveBareMetalPricingResourceCodes(configs: ResourceConfigEntry[] = BARE_METAL_RESOURCE_CONFIGS): Set<string> {
  return resolvePricingResourceCodes(configs);
}
